import branch from 'branch-sdk';
import { branchApiKey } from '../verticalConfigs';

export async function createBranchLink({ senderId, path, data = {} }) {
  // eslint-disable-next-line consistent-return
  return new Promise((resolve, reject) => {
    const key = branchApiKey();
    if (!key) return reject(new Error('Missing Branch API key'));

    // eslint-disable-next-line consistent-return
    branch.init(key, {}, err => {
      if (err) return reject(err);

      branch.link(
        {
          tags: ['web'],
          channel: 'web',
          data: {
            $deeplink_path: `sender_id/${senderId}${path}`,
            sender_id: senderId,
            ...data,
          },
        },
        (error, url) => {
          if (error) return reject(error);
          return resolve(url);
        },
      );
    });
  });
}
